export enum DataFetchModeEnum {
    List = 'list',
    LastValue = 'lastValue',
    ListAggregated = 'listAggregated',
    Aggregated = 'aggregated'
}
